/*
 * @Author: luxiangqiang
 * @Date: 2023-05-04 10:10:43
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-05-04 15:45:17
 */

export const tabs = [
  {
    tab: '亚洲',
    countries: [
      {
        name: '越南',
        count: '28294',
        num: 160
      },
      {
        name: '印尼',
        count: '26491',
        num: 150
      },
      {
        name: '泰国',
        count: '25210',
        num: 120
      },
      {
        name: '日本',
        count: '23100',
        num: 100
      },
      {
        name: '菲利宾',
        count: '18620',
        num: 50
      },
    ]
  },
  {
    tab: '美洲',
    countries: [
      {
        name: '美国',
        count: '20765',
        num: 150
      },
      {
        name: '巴西',
        count: '13716',
        num: 100
      },
      {
        name: '阿根廷',
        count: '10484',
        num: 80
      },
      {
        name: '墨西哥',
        count: '9388',
        num: 70
      },
      {
        name: '智利',
        count: '8289',
        num: 60
      },
    ]
  },
  {
    tab: '欧洲',
    countries: [
      {
        name: '德国',
        count: '14427',
        num: 150
      },
      {
        name: '英国',
        count: '12728',
        num: 120
      },
      {
        name: '法国',
        count: '10036',
        num: 100
      },
      {
        name: '塞尔维亚',
        count: '7636',
        num: 80
      },
      {
        name: '波兰',
        count: '7525',
        num: 70
      },
    ]
  },
  {
    tab: '非洲',
    countries: [
      {
        name: '埃及',
        count: '15108',
        num: 150
      },
      {
        name: '阿联酋',
        count: '13855',
        num: 130
      },
      {
        name: '尼日利亚',
        count: '12954',
        num: 120
      },
      {
        name: '沙特阿拉伯',
        count: '12947',
        num: 115
      },
      {
        name: '阿尔及利亚',
        count: '12232',
        num: 110
      },
    ]
  },
];
